// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"07a11401","337":"bb4a01e1","917":"0a6cc976"}[chunkId] + ".chunk.css";
};